
import React from 'react'
// "url('/assets/home-grid/family-fun-book-logo.jpg') "
const HeroBanner = ({ bannerTitle, bannerDescription, bannerImage }) => {
  return (

    // style={{ backgroundImage: "url('assets/home-grid/family-fun-book-logo.jpg')" }}
    // bg-[#f0f0f0]
    <div style={{ backgroundImage: `url(${bannerImage})` }} className='hero-banner-image-wrapper  h-[50dvh] w-full flex items-center justify-center'>
      {/* <div style={{ backgroundImage: "url('/assets/home-grid/family-fun-book-logo.jpg') " }} className='hero-banner-image-wrapper  h-[40dvh] w-full flex items-center justify-center'> */}
      {/* <div className=""> */}
      {/* <img src="assets/home-grid/family-fun-book-logo.jpg" alt="hero-banner-image" /> */}
      {/* </div> */}
      <div className="container mx-auto">
        <h1 className='restaurant-title text-black text-center z-10 relative white-title'> {bannerTitle}</h1>
        {/* Find the Perfect Plan for You! */}
        <p className='vendor-hero-description text-center text-black z-10 relative white-title'> {bannerDescription}</p>
        {/* Explore our tailored plans and pick the one that meets your needs. Flexibility and value, just for you. */}
      </div>
    </div>
  )
}

export default HeroBanner